import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreatePortfolioComponent } from './create-portfolio.component';
import { RolesGuard } from '../../../gaurds/roles.guard';

const routes: Routes = [
  {
    path: '',
    component: CreatePortfolioComponent,
    canActivate: [RolesGuard],
    data: {
      allowedRoles: ['pmo', 'admin']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreatePortfolioRoutingModule { }
